exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-of-airports[data-v-54e7419c] .multiselect__input,.select-of-airports[data-v-54e7419c] .multiselect__option,.select-of-airports[data-v-54e7419c] .multiselect__placeholder,.select-of-airports[data-v-54e7419c] .multiselect__single{font-size:.8125rem}.select-of-airports[data-v-54e7419c] .multiselect__tags{min-height:28px;padding:4px 8px}.select-of-airports[data-v-54e7419c] .multiselect__content-wrapper{max-height:200px}", ""]);

// exports
